// Arabic-Indic number + relative-time formatting for the Majlis page.
// The mockup renders every numeral in Arabic-Indic digits (٤٧، منذ ٣ س).

const fmt = new Intl.NumberFormat("ar-EG");

/** 47 → "٤٧" (with Arabic thousands separators for big numbers). */
export function arabicDigits(n) {
  if (n == null || Number.isNaN(Number(n))) return "٠";
  return fmt.format(Number(n));
}

/** ISO timestamp → "الآن" / "منذ ٥ د" / "منذ ٣ س" / "منذ ٤ ي". */
export function arabicRelativeTime(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "الآن";
  if (s < 3600) return `منذ ${arabicDigits(Math.floor(s / 60))} د`;
  if (s < 86400) return `منذ ${arabicDigits(Math.floor(s / 3600))} س`;
  return `منذ ${arabicDigits(Math.floor(s / 86400))} ي`;
}
